import dayjs from 'dayjs'

export function normalizeDate(dateStr: string | null | undefined): string | null {
  if (!dateStr) return null
  const trimmed = String(dateStr).trim()
  if (
    !trimmed ||
    trimmed === '0000-00-00' ||
    trimmed.startsWith('0000-00-00') ||
    trimmed === 'null' ||
    trimmed === 'undefined'
  ) {
    return null
  }

  const datePart = trimmed.split(' ')[0]

  if (datePart.includes('.')) {
    const parts = datePart.split('.')
    if (parts.length === 3) {
      const day = parts[0].padStart(2, '0')
      const month = parts[1].padStart(2, '0')
      const year = parts[2]
      if (year.length === 4) {
        return `${year}-${month}-${day}`
      }
    }
  }

  if (datePart.includes('-')) {
    const parts = datePart.split('-')
    if (parts.length === 3) {
      const year = parts[0]
      const month = parts[1].padStart(2, '0')
      const day = parts[2].padStart(2, '0')
      if (year.length === 4) {
        return `${year}-${month}-${day}`
      }
    }
  }

  const d = dayjs(trimmed)
  return d.isValid() ? d.format('YYYY-MM-DD') : null
}
